import {
  Component,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnInit
} from "@angular/core";
import { NgForm } from "@angular/forms";
import { GestioneLoginService } from "./../servizi/login/gestione-login.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EbwModalService } from "../library/ebw-modals-angular/ebw-modal.service";
import { UtilsService } from "../servizi/utils.service";
import { DomSanitizer } from "@angular/platform-browser";
import { NGXLogger } from "ngx-logger";
// import { AccessLogService } from "../servizi/access-log.service";
import { RouterService } from "../servizi/router.service";
import { ActivatedRoute } from "@angular/router";
import { faWrench } from "@fortawesome/free-solid-svg-icons";
import { IConfigGlobale } from "../modelli/config-globale.model";
import ConfiGlobaleJson from "src/assets/config/config-globale.dev.json";
import { faUser } from '@fortawesome/free-solid-svg-icons';

/** Componente che gestisce il login al portale */
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements AfterViewInit {
  /** form di login */
  @ViewChild("f", { static: false }) signupForm: NgForm;

  /** json delle notifiche */
  notifiche: any;

  faWrench = faWrench;

  faUserIcon = faUser;

  configGlobale: IConfigGlobale;
  logo: string = "./assets/img/logo/logo-payoff-horizontal-s.svg";
  isINWIT: boolean = false;
  isGiornaleLavori: boolean = false;

  private readonly pageComponentName: string = "LOGIN";

  // --------------------------------------------------------------------------------------------------------------
  constructor(
    private route: ActivatedRoute,
    private routerSrv: RouterService,
    private elementRef: ElementRef,
    private loginServ: GestioneLoginService,
    private modal: NgbModal,
    private ebwModalService: EbwModalService,
    private utilsServ: UtilsService,
    private sanitizer: DomSanitizer,
    private logger: NGXLogger,
    // private accessLogService: AccessLogService
  ) { }

  // --------------------------------------------------------------------------------------------------------------

  ngOnInit() {
    this.configGlobale = ConfiGlobaleJson as IConfigGlobale;

    // Microsoft Azure AD SSO

    // Il Login viene richiamato dall'api auth/callback dopo che è avvenuta l'autenticazione
    // su Azure AD. 
    // All'url in questo caso vengono aggiunti l'access_token e il refresh_token

    this.route.queryParams.subscribe((params) => {

      const errorCode = params['error'];

      if (errorCode) {
        this.ebwModalService.openErrorModal({ title: `Errore Login`, content: this.loginServ.getErrorMessage(errorCode) });
        return;
      }

      // Recupera i token dall'URL
      const accessToken = params["access_token"];
      const refreshToken = params["refresh_token"];

      if (accessToken && refreshToken) {

        // Salva i token nel SessionStorage per l'uso nelle future chiamate API
        this.loginServ.setToken(accessToken);
        this.loginServ.setRefresh(refreshToken);

        this.routerSrv.navigateToChild("mappa", { login: true });
      }
      else {
        // Se i Token non sono presenti resto nella schermata di login non autenticata
      }
    });

    this.logo = this.configGlobale.styles.logoLight;

    this.isINWIT = this.configGlobale.context.application == "INWIT";
    this.isGiornaleLavori = this.configGlobale.context.application == "GiornaleLavori";
  }

  // --------------------------------------------------------------------------------------------------------------

  ngAfterViewInit() {
    // cambio il colore dello sfondo
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = "grey";
  }

  // --------------------------------------------------------------------------------------------------------------

  // Microsoft Azure AD SSO

  /**
   * Per modificare il FE in modo che venga effettuato il reindirizzamento alla
   * schermata di login di Azure, aggiorniamo la funzione onLogin() per fare un semplice
   * redirect alla rotta di login del backend. 
   * 
   * Quando l'utente visita la rotta /auth/login
   * nel backend, questo lo reindirizzerà automaticamente alla schermata di login di Azure AD.
   * Non c'è quindi bisogno di una richiesta HTTP al backend in getLogin(), ma semplicemente
   * di una navigazione o un redirect alla rotta appropriata.
   *
   * La funzione this.loginServ.getLogin() non sarà più necessaria, poiché il login verrà gestito tramite il redirect diretto.
   *
   * Dopo il login su Azure AD, l'utente viene reindirizzato al backend alla rotta /auth/callback, che gestisce i token e li
   * inoltra al FE.
   *
   * Una volta ricevuti i token nel FE (this.route.queryParams.subscribe), si può navigare alla pagina principale dell'app 
   * (mappa o altre rotte protette), utilizzando il token per autenticare le successive richieste alle API protette.
   */
  onLogin() {
    // Reindirizza alla rotta di login del backend, che avvia il processo di autenticazione di Azure AD.
    window.location.href = this.loginServ.creaURL('login', 'get_token') + `?is_admin=false`;
  }

  // --------------------------------------------------------------------------------------------------------------

  onKeyPressed(event) {
    // se premuto invio richiamo il login
    if (event.code === "Enter") {
      this.onLogin();
    }
  }

  // --------------------------------------------------------------------------------------------------------------

  openModal(categoria) {
    // verifico le notifiche da leggere relative all'utente
    const visUrl = this.utilsServ.creaURL("notifiche", "view");
    const visPar = { categoria };

    this.utilsServ.postRequest(visUrl, visPar).subscribe(
      (resp: { error: number; status: number; data: any }) => {
        let content: string;
        let title: any;

        if (resp.error === 0) {
          const notifiche = resp.data;

          /** le 5 notifiche configurate per i diversi bottoni del menù di login sono univoche.
           *  Ovvero, ad ogni bottone del menù di login è associata una modale (con relativo titolo)
           *  che mostra un unico record (titolo modale + testo) della tabella notifiche
           */
          notifiche.forEach((notifica: { testo: string; titolo: any }) => {
            // sanifico il testo (altrimenti lo style viene escluso per motivi di sicurezza)
            // tslint:disable-next-line: no-string-literal
            content = this.sanitizer.bypassSecurityTrustHtml(notifica.testo)[
              "changingThisBreaksApplicationSecurity"
            ];
            title = notifica.titolo;
          });

          if (!!!content || content === "") {
            content = "Contenuto non disponibile";
          }

          this.ebwModalService.openInfoModal(
            { title, content },
            {
              ariaLabelledBy: "modal-basic-title",
              centered: true,
              scrollable: true,
              windowClass: "modalFull95"
            }
          );
        }
      },
      (error) => this.logger.error(error)
    );
  }
}
